export default {
  organizationUser: "ORG",
  vendorUser: "VENDOR",
  patientUser: "PATIENT",
};
